<template>
  <div class="container" v-if="!loading">
    <img :src="codeUrl" class="qrcode" />
    <p class="location">{{ buildingName }} {{ blockHomeName }}</p>
    <p class="time">{{ endTime }} 过期</p>
  </div>
</template>

<script>
import { queryNewHomeVisitorInfo } from '@/services/api'
export default {
  data() {
    return {
      codeUrl: null,
      buildingName: null,
      blockHomeName: null,
      endTime: null,
      loading: false,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const url = window.location.href
      const recordId = url.split('=')[1]

      this.loading = true
      try {
        const res = await queryNewHomeVisitorInfo(recordId)
        const data = {
          codeUrl: res.codeUrl,
          // buildingName: '新柏石办公室',
          blockHomeName: res.blockHomeName,
          endTime: res.endTime,
        }
        Object.assign(this, data)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  display: flex;
  padding: 24px 16px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin-bottom: 16px;
  }
}
.qrcode {
  width: 100%;
}
.location {
  font-size: 20px;
  font-weight: 500;
}
.time {
  color: rgba(0, 0, 0, 0.45);
}
</style>
